
import { db } from "../../server";
import { interpolate } from "../helpers/stringHelper"
import { paths } from "../constants/dbPaths";

export function getMessageTemplates(storeId) {
  return db.collection(interpolate(paths.MessageTemplateCollection, storeId));
}